"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  DOMAIN_FOR_LANGUAGE_EDIT: 'domainForLanguageEdit',
  EDIT_DOMAIN_LANGUAGE_MODAL_OPEN: 'editDomainLanguageModalOpen',
  REDIRECT_TO_AFFECTED_PAGES_MODAL_OPEN: 'redirectToAffectedPagesModalOpen',
  NEW_DOMAIN_LANGUAGE: 'newDomainLanguage',
  OLD_DOMAIN_LANGUAGE: 'oldDomainLanguage',
  UPDATE_PAGE_URL_MODAL_OPEN: 'updatePageUrlModalOpen',
  EDIT_PAGE_OPTIONS_MODAL_OPEN: 'editPageOptionsModalOpen',
  PAGE_FOR_URL_EDIT: 'pageForUrlEdit',
  EDIT_PAGE_URLS_OPEN: 'editPageUrlsOpen',
  EDIT_PAGE_URLS_TABLE_OPEN: 'editPageUrlsTableOpen',
  EDIT_PAGE_URLS_TABLE_INDEX: 'editPageUrlsTableIndex',
  ADD_PAGE_TO_SITEMAP_MODAL_OPEN: 'addPageToSitemapModalOpen',
  PAGES_FOR_SITEMAP_INDEX: 'pagesForSitemapIndex',
  FILTER_FOR_SITEMAP: 'filterForSitemap',
  DOMAIN_FOR_SITEMAP: 'domainForSitemap',
  SITEMAP_PAGE_FOR_EDIT: 'sitemapPageForEdit'
};
exports.default = _default;
module.exports = exports.default;